import { COMPANY_CONFIGS } from "@/config/companies";
import { CompanyAppPage } from "@/components/company-portal/CompanyAppPage";

export default function InnoventureApp() {
  const config = COMPANY_CONFIGS.innoventure;
  return <CompanyAppPage config={config} />;
}
